import { render } from "./confirmAGCAREOrder.vue?vue&type=template&id=0fa7a3ed&scoped=true"
import script from "./confirmAGCAREOrder.vue?vue&type=script&lang=js"
export * from "./confirmAGCAREOrder.vue?vue&type=script&lang=js"

import "./confirmAGCAREOrder.vue?vue&type=style&index=0&id=0fa7a3ed&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa7a3ed"]])

export default __exports__